import React from 'react';
import { Icon } from '../../../../concepts/resources/Icon';
import { AdfNodeProps } from './AdfModelTypes';

export const AdfBlockCard = React.memo(({ node }: AdfNodeProps) => {
    return <div className="block-card">
        <Icon size="1.25" src="deqo://icons/d2/jira" />
        {node.attrs?.url}
    </div>;
});
